import { legs3DRondeComponents } from './legs-3-d-ronde.js';
import { legs3DComponents } from './legs-3-d.js';
import { legsAxelComponents } from './legs-axel.js';
import { legsBragoComponents } from './legs-brago.js';
import { legsButterflyComponents } from './legs-butterfly.js';
import { legsClassicoComponents } from './legs-classico.js';
import { legsConoComponents } from './legs-cono.js';
import { legsDiamondComponents } from './legs-diamond.js';
import { legsEbonu3DoubleComponents } from './legs-ebonu-3-double.js';
import { legsEbonu3Components } from './legs-ebonu-3.js';
import { legsEbonuComponents } from './legs-ebonu.js';
import { legsEbuComponents } from './legs-ebu.js';
import { legsElmoDoubleComponents } from './legs-elmo-double.js';
import { legsElmoComponents } from './legs-elmo.js';
import { legsFalkeComponents } from './legs-falke.js';
import { legsFlyComponents } from './legs-fly.js';
import { legsHarper3Components } from './legs-harper-3.js';
import { legsHarperComponents } from './legs-harper.js';
import { legsJulio3Components } from './legs-julio-3.js';
import { legsJulio4Components } from './legs-julio-4.js';
import { legsLivioSchuinComponents } from './legs-livio-schuin.js';
import { legsLivioComponents } from './legs-livio.js';
import { legsMPootRechtComponents } from './legs-m-poot-recht.js';
import { legsMPootSchuinComponents } from './legs-m-poot-schuin.js';
import { legsMadridComponents } from './legs-madrid.js';
import { legsNewlyComponents } from './legs-newly.js';
import { legsNovaroDoubleComponents } from './legs-novaro-double.js';
import { legsNovaroComponents } from './legs-novaro.js';
import { legsOdil3Components } from './legs-odil-3.js';
import { legsOdil4Components } from './legs-odil-4.js';
import { legsOsloComponents } from './legs-oslo.js';
import { legsOxfordComponents } from './legs-oxford.js';
import { legsPapillonStrakComponents } from './legs-papillon-strak.js';
import { legsPapillonComponents } from './legs-papillon.js';
import { legsPinoComponents } from './legs-pino.js';
import { legsRafinoComponents } from './legs-rafino.js';
import { legsRobuDoubleComponents } from './legs-robu-double.js';
import { legsRobuComponents } from './legs-robu.js';
import { legsRoiaComponents } from './legs-roia.js';
import { legsTPootRondeComponents } from './legs-t-poot-ronde.js';
import { legsTPootComponents } from './legs-t-poot.js';
import { legsTrapeziumComponents } from './legs-trapezium.js';
import { legsTwist3Components } from './legs-twist-3.js';
import { legsTwist4Components } from './legs-twist-4.js';
import { legsUPootComponents } from './legs-u-poot.js';
import { legsWithOffsetComponents } from './legs-with-offset.js';
import { legsWithThicknessComponents } from './legs-with-thickness.js';
import { legsXPootComponents } from './legs-x-poot.js';
import { legsComponents } from './legs.js';
import { oakLegsComponents } from './oak-legs.js';
import { steelLegsComponents } from './steel-legs.js';
import { tableComponents } from './table.js';
import { topCircleComponents } from './top-circle.js';
import { topDanishOvalComponents } from './top-danish-oval.js';
import { topHalfCircleComponents } from './top-half-circle.js';
import { topHalfOvalComponents } from './top-half-oval.js';
import { topOvalComponents } from './top-oval.js';
import { topRectangleComponents } from './top-rectangle.js';
import { topWithLengthAndWidthComponents } from './top-with-length-and-width.js';
import { topComponents } from './top.js';
export const generatedComponents = [
    ...topComponents,
    ...legsComponents,
    ...tableComponents,
    ...legs3DComponents,
    ...legs3DRondeComponents,
    ...legsAxelComponents,
    ...legsBragoComponents,
    ...legsButterflyComponents,
    ...legsClassicoComponents,
    ...legsConoComponents,
    ...legsDiamondComponents,
    ...legsEbonuComponents,
    ...legsEbonu3Components,
    ...legsEbonu3DoubleComponents,
    ...legsEbuComponents,
    ...legsElmoComponents,
    ...legsElmoDoubleComponents,
    ...legsFalkeComponents,
    ...legsFlyComponents,
    ...legsHarperComponents,
    ...legsHarper3Components,
    ...legsJulio3Components,
    ...legsJulio4Components,
    ...legsLivioComponents,
    ...legsLivioSchuinComponents,
    ...legsMadridComponents,
    ...legsMPootRechtComponents,
    ...legsMPootSchuinComponents,
    ...legsNewlyComponents,
    ...legsNovaroComponents,
    ...legsNovaroDoubleComponents,
    ...legsOsloComponents,
    ...legsOdil3Components,
    ...legsOdil4Components,
    ...legsOxfordComponents,
    ...legsPapillonComponents,
    ...legsPapillonStrakComponents,
    ...legsPinoComponents,
    ...legsRafinoComponents,
    ...legsRobuComponents,
    ...legsRobuDoubleComponents,
    ...legsRoiaComponents,
    ...legsTPootComponents,
    ...legsTPootRondeComponents,
    ...legsTrapeziumComponents,
    ...legsTwist3Components,
    ...legsTwist4Components,
    ...legsUPootComponents,
    ...legsXPootComponents,
    ...legsWithOffsetComponents,
    ...legsWithThicknessComponents,
    ...steelLegsComponents,
    ...oakLegsComponents,
    ...topCircleComponents,
    ...topDanishOvalComponents,
    ...topHalfCircleComponents,
    ...topHalfOvalComponents,
    ...topOvalComponents,
    ...topRectangleComponents,
    ...topWithLengthAndWidthComponents
];

//# sourceMappingURL=index.js.map